import useFavorites from '@/hooks/useFavorites';

interface FavoriteButtonProps {
  movieId: string;
  variant?: 'solid' | 'outline';
}

export default function FavoriteButton({ movieId, variant = 'solid' }: FavoriteButtonProps) {
  const { isFavorite, toggleFavorite } = useFavorites();
  const active = isFavorite(movieId);

  if (variant === 'outline') {
    return (
      <button
        type="button"
        onClick={() => toggleFavorite(movieId)}
        className={`flex items-center gap-2 whitespace-nowrap rounded-md border px-4 py-2.5 font-label text-sm transition-colors cursor-pointer ${
          active
            ? 'border-accent-400 bg-accent-100 text-accent-900'
            : 'border-background-300 bg-background-50 text-foreground-800 hover:bg-secondary-100'
        }`}
      >
        <i className={active ? 'ri-bookmark-fill' : 'ri-bookmark-line'} aria-hidden="true" />
        {active ? '已收藏' : '收藏'}
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={() => toggleFavorite(movieId)}
      className={`flex items-center gap-2 whitespace-nowrap rounded-md px-5 py-2.5 font-label text-sm font-semibold transition-colors cursor-pointer ${
        active
          ? 'bg-accent-500 text-primary-950 hover:bg-accent-400'
          : 'bg-background-50/15 text-background-50 backdrop-blur-sm hover:bg-background-50/25'
      }`}
    >
      <i className={active ? 'ri-bookmark-fill' : 'ri-bookmark-line'} aria-hidden="true" />
      {active ? '已收藏' : '收藏影片'}
    </button>
  );
}